import { Spinner } from "@components/ui-kit";
import {
  useGetDocumentDependenciesForClientLazyQuery,
  useGetDocumentDependenciesLazyQuery,
} from "@src/__generated__/graphql";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { CardListDocuments } from "./CardListDocuments";
import { MixedFilters } from "./MixedFilters";
import { DocumentsCtx, StoreDocuments } from "./StoreDocuments";

/**
 * encapsulate initial data fetch & refetch
 */
export function useDocumentData(store: StoreDocuments) {
  const [fetchDocDependencies, docDependenciesReq] =
    useGetDocumentDependenciesLazyQuery({
      onCompleted(data) {
        store.fromGetDocumentDependenciesQuery(data);
      },
    });
  const [fetchClientDocDependencies, clientDocDependenciesReq] =
    useGetDocumentDependenciesForClientLazyQuery({
      onCompleted(data) {
        store.fromGetDocumentDependenciesForClientQuery(data);
      },
    });

  useEffect(() => {
    if (store.prefillFormFields.clientId) {
      fetchClientDocDependencies({
        variables: {
          clientId: store.prefillFormFields.clientId,
        },
      });
    } else {
      fetchDocDependencies({
        variables: {
          brandId: store.prefillFormFields.brandId,
          orIdIn: store.prefillFormFields.projectIds ?? [],
        },
      });
    }
  }, []);

  store.error = docDependenciesReq.error || clientDocDependenciesReq.error;
  store.loading =
    docDependenciesReq.loading || clientDocDependenciesReq.loading;
}

export const PageDocuments = withCan(
  { do: ["contract_read", "order_read", "otherDocument_read"] },
  observer(function PageDocuments() {
    const { query } = useRouter();

    const [store] = useState(() => {
      const store = new StoreDocuments(new MixedFilters());
      store.setQuickFilterFromURL(query);
      store.where.fromURLSearchParam(query);
      store.orderBy.fromURLSearchParam(query);
      store.pagination.fromURLSearchParam(query);
      return store;
    });

    useUpdateURI(store.searchParams);
    useDocumentData(store);

    const { loading } = store;

    return (
      <DocumentsCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            {loading && <Spinner absolute />}
            <CardListDocuments />
          </div>
        </div>
      </DocumentsCtx.Provider>
    );
  }),
);
